import { PopupInfoModel, EnumPopupFunctions } from "../Managers/dataStructures";

import PopUpScreen from "./PopUpScreen";

export default function Dialog(
  item: PopupInfoModel,
  closePopup: () => void,
  redirect: (item: PopupInfoModel) => void
) {
  const isLargeDialog: boolean =
    item.ftype === EnumPopupFunctions.ADD_USER ||
    item.ftype === EnumPopupFunctions.USER_DETAIL ||
    item.ftype === EnumPopupFunctions.EDIT_USER ||
    item.ftype === EnumPopupFunctions.BM_REPORT_DETAIL ||
    item.ftype === EnumPopupFunctions.ADMIN_REPORT_DETAIL;
  let dialogSize: string = isLargeDialog ? "w-4/5" : "lg:w-2/5 w-4/5";
  const isMediumDialog: boolean =
    item.ftype === EnumPopupFunctions.ADD_SHIFT ||
    item.ftype === EnumPopupFunctions.EDIT_SHIFT;
  dialogSize = isMediumDialog ? "lg:w-1/4" : dialogSize;
  const dialogColorBG: string =
    item.ftype === EnumPopupFunctions.TL_USER_LOGIN_DIALOG_REDIRECTION ||
    item.ftype === EnumPopupFunctions.ALERT_DIALOG ||
    item.ftype === EnumPopupFunctions.ADD_SHIFT ||
    item.ftype === EnumPopupFunctions.EDIT_SHIFT
      ? " "
      : "bg-white shadow-xl";
  return (
    <div
      className="relative z-50"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div
        className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
        aria-hidden="true"
      ></div>

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <div
            className={
              "relative transform overflow-hidden rounded-lg px-4 pb-4 pt-5 text-left transition-all sm:my-8 sm:p-6 " +
              dialogSize +
              " " +
              dialogColorBG
            }
          >
            {PopUpScreen(item, closePopup, redirect)}
          </div>
        </div>
      </div>
    </div>
  );
}
